export { default as ProductSideBySide } from './ProductSideBySide';
